/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  GrantAcceptanceTemplateService,
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-award-service';
import { ModalStatusType } from '../../types/common';

const usePostGrantAcceptanceTemplate = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  modalStatus: ModalStatusType
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (modalStatus === 'Add Versions') {
        return await handleRequest(
          GrantAcceptanceTemplateService.postApiAwardApiAppGrantAcceptanceTemplateContent(payload)
        );
      } else {
        if (payload.contentId) {
          return await handleRequest(
            GrantAcceptanceTemplateService.putApiAwardApiAppGrantAcceptanceTemplateContent(payload)
          );
        } else {
          return await handleRequest(
            GrantAcceptanceTemplateService.postApiAwardApiAppGrantAcceptanceTemplate(payload)
          );
        }
      }
    },
    {
      onSuccess: async (
        response: Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
        payload: any
      ) => {
        if (response) {
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Grant Acceptance Template ${payload.contentId ? 'edited' : 'created'}.`}
            />
          );
          await queryClient.invalidateQueries('getGrantAcceptanceTemplateList');
          await queryClient.invalidateQueries('getGrantAcceptanceTemplateOptions');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostGrantAcceptanceTemplate;
